import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpBaseService } from './http-base.service';
import { AuthService } from './auth.sevice';
import { AuthTokenHelper } from '../helpers/auth-token-helper';
import { DatePipe } from '@angular/common'
import { ClinicalNote } from '../models/appointments/clinicalnote.model';

@Injectable()
export class ClinicalNoteService {
  private readonly API_URL = 'assets/data/appointment.json';
  dataChange: BehaviorSubject<ClinicalNote[]> = new BehaviorSubject<ClinicalNote[]>([]);
  public apiURL = '';
  dialogData: any;
  constructor(private httpClient: HttpClient, private httpService: HttpBaseService) { }

  get data(): ClinicalNote[] {
    return this.dataChange.value;
  }

  addClincalNote(clincalNote: ClinicalNote): void {   
    this.getAPIURL();
    this.httpService.post(this.apiURL + "clinicalnote/Create", clincalNote, true).subscribe(response => {
    }, error => {
      if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
        return false;
      }
    });
  }

  updateClincalNote(clincalNote: ClinicalNote) {
    try {
      this.getAPIURL();
      return this.httpService.post(this.apiURL + "clinicalnote/Edit", clincalNote);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  updateNotes(URL): Observable<any> {
    try {
      this.getAPIURL();
      const body = {};
      return this.httpService.get(this.apiURL + URL, body);      
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  getAPIURL(): void {
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}`;
    })
  }
}

